/**
 * format-specs.ts — Canonical Product & Line Item Specs Formatter
 * 
 * Single Source of Truth cho việc chuyển đổi mọi định dạng specs kỹ thuật (JSON object,
 * JSON string, legacy string, dimensions, printSize, purchaseSize) thành chuỗi hiển thị
 * chuẩn tiếng Việt cho ngành in bao bì.
 * 
 * BẤT BIẾN NGHIỆP VỤ:
 * 1. Hàm LUÔN LUÔN trả về chuỗi nguyên thủy (string).
 * 2. TUYỆT ĐỐI KHÔNG BAO GIỜ trả về JavaScript Object, null hay undefined làm vỡ React DOM (Anti-React Error #31).
 */

export function formatProductSpecs(specsRaw: any, product?: any): string {
  try {
    // 1. Kích thước 3 chiều từ product trực tiếp
    if (product && typeof product === 'object') {
      const l = product.length;
      const w = product.width;
      const h = product.height;
      if (l && w) {
        return `${l}x${w}${h ? `x${h}` : ''} mm`;
      }
    }

    if (specsRaw === null || specsRaw === undefined) {
      return product?.packingSpec ? String(product.packingSpec) : '';
    }

    // 2. Xử lý specsRaw
    let parsed: any = null;

    if (typeof specsRaw === 'object') {
      parsed = specsRaw;
    } else if (typeof specsRaw === 'string') {
      const trimmed = specsRaw.trim();
      if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
        try {
          parsed = JSON.parse(trimmed);
        } catch {
          return trimmed;
        }
      } else {
        return trimmed;
      }
    } else {
      return String(specsRaw);
    }

    if (!parsed || typeof parsed !== 'object') {
      return String(parsed || '');
    }

    // 3. Trích xuất thông tin có ý nghĩa từ parsed JSON object
    if (parsed.dimensions && typeof parsed.dimensions === 'string') {
      return parsed.dimensions;
    }
    if (parsed.size && typeof parsed.size === 'string') {
      return parsed.size;
    }
    if (parsed.legacy && typeof parsed.legacy === 'string') {
      return parsed.legacy;
    }

    const parts: string[] = [];

    // Kích thước 3 chiều từ JSON object
    if (parsed.dai || parsed.rong || parsed.cao) {
      parts.push(`${parsed.dai || 0}x${parsed.rong || 0}${parsed.cao ? `x${parsed.cao}` : ''} mm`);
    }

    // Khổ giấy in & Khổ giấy mua
    if (parsed.printSize) {
      parts.push(`Khổ in: ${parsed.printSize}`);
    }
    if (parsed.purchaseSize && parsed.purchaseSize !== parsed.printSize) {
      parts.push(`Khổ mua: ${parsed.purchaseSize}`);
    }

    // Bổ sung chất liệu / màu in nếu product có
    if (product && typeof product === 'object') {
      const matName = product.material?.name || product.material?.materialId || product.paperType;
      if (matName && typeof matName === 'string') {
        parts.push(matName);
      }
      if (product.printColors && typeof product.printColors === 'string') {
        parts.push(product.printColors);
      }
    }

    if (parts.length > 0) {
      return parts.join(' • ');
    }

    // 4. Fallback cuối cùng
    if (product?.packingSpec) {
      return String(product.packingSpec);
    }

    return '';
  } catch {
    return '';
  }
}
